// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"383e697b575c7ed1","4044":"a8ca941e58af6d54","4515":"383e697b575c7ed1","4969":"60167c1902198da7","5264":"4a7e23b22514ceee","8378":"06101e4d0c313e2d"}[chunkId] + ".css";
};